import React from 'react';
import { useAsync } from 'react-use';
import { Category, ImageApi, TourTestimonial } from '@model/iceberg';
import { TripTypes } from '@model/common';
import { TourTestimonialHero } from '@components/common/hero/testimonial/TourTestimonialHero';

export interface ComponentData {}

interface TestimonialHeroContainerProps {
  path: string;
  destinationName: string;
  testimonials: Array<TourTestimonial>;
  tripType: TripTypes;
}

export const TourTestimonialHeroContainer = ({
  path,
  testimonials,
  destinationName,
  tripType
}: TestimonialHeroContainerProps) => {
  const api: ImageApi = new ImageApi();

  const {
    value: image,
    error,
    loading
  } = useAsync(async () => await api.images({ category: Category.HUMAN, path, count: 1 }), [path]);

  if (error || loading || !image?.images || !image?.images.length) return null;

  return (
    <TourTestimonialHero
      image={image}
      testimonials={testimonials}
      destinationName={destinationName}
      tripType={tripType}
    />
  );
};
